import classNames from 'classnames'
import { useContext } from 'react'
import { useDrop } from 'react-dnd'

import { MosaicContext } from './contextTypes'
import { MosaicDropData, MosaicDropTargetPosition } from './internalTypes'
import { MosaicPath } from './models/mosaic'
import { MosaicDragItem, MosaicDragType } from './models/mosaicDragType'

export interface MosaicDropTargetProps {
  position: MosaicDropTargetPosition
  path: MosaicPath
}

export function MosaicDropTarget({ path, position }: MosaicDropTargetProps) {
  const { mosaicId } = useContext(MosaicContext)
  const [{ isOver, draggedMosaicId }, connectDropTarget] = useDrop({
    accept: [MosaicDragType.WINDOW, MosaicDragType.WIDGET_BUTTON, MosaicDragType.TREE_ITEM],
    drop: (item: MosaicDragItem | undefined, _monitor): MosaicDropData => {
      if (mosaicId === item?.mosaicId) {
        return { path, position }
      } else {
        return {}
      }
    },
    collect: (monitor) => {
      return ({
        isOver: monitor.isOver(),
        draggedMosaicId: (monitor.getItem() || {}).mosaicId,
      })
    },
  })

  return (
    <div
      ref={connectDropTarget}
      className={classNames('drop-target', position, {
        'drop-target-hover': isOver && draggedMosaicId === mosaicId,
      })}
    >
    </div>
  )
}
